import { useCallback } from 'react';

import { HorizontalContainer, QuestionMarkIcon } from '@american-autonomy/rantizo-ui';

import LargeSemiboldText from 'components/text/LargeSemiboldText';

import useTranslation from './hooks/useTranslation';

import { HELP_URL, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const HelpLink: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }) => {
    const { HELP } = useTranslation();

    const handleGoToHelpPage = useCallback(() => {
        window.open(HELP_URL, '_blank');
    }, []);

    return (
        <HorizontalContainer
            className={`${className} ${styles.helpLink}`}
            onClick={handleGoToHelpPage}
            testId={testId}
        >
            <QuestionMarkIcon className={styles.questionMarkIcon} />

            <LargeSemiboldText text={HELP} />
        </HorizontalContainer>
    );
};

export default HelpLink;
